import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import S from './Cta.styled'
import * as Svg from '../Svg'

const Cta = forwardRef(
  (
    {
      text,
      to = '',
      className = '',
      onClick = () => {},
      buttonType = 'primary',
      bgColor = '',
      textColor = '',
      customStateColors = {},
      icon = '',
      iconPosition = 'before',
      linkComponent: RouteLink,
      isDisabled = false,
      blank = false,
      fontSize = 'm',
      ...rest
    },
    ref
  ) => {
    const SvgIcon = Svg[icon]

    const buttonContent = (
      <>
        {icon && iconPosition === 'before' && (
          <SvgIcon className="icon-before" />
        )}
        {text}
        {icon && iconPosition === 'after' && <SvgIcon className="icon-after" />}
      </>
    )

    return (
      <S.Cta
        className="cta"
        buttonType={buttonType}
        bgColor={bgColor}
        textColor={textColor}
        isDisabled={isDisabled}
        ref={ref}
        icon={icon}
        iconPosition={iconPosition}
        onMouseDown={(e) => e.preventDefault()}
        fontSize={fontSize}
        customStateColors={customStateColors}
      >
        {RouteLink ? (
          <RouteLink to={to} className={className} onClick={onClick} {...rest}>
            {buttonContent}
          </RouteLink>
        ) : to ? (
          <a
            href={to}
            className={className}
            onClick={onClick}
            target={blank ? '_blank' : ''}
            rel={blank ? 'noopener noreferrer' : ''}
            {...rest}
          >
            {buttonContent}
          </a>
        ) : (
          <button
            className={className}
            onClick={onClick}
            disabled={isDisabled}
            {...rest}
          >
            {buttonContent}
          </button>
        )}
      </S.Cta>
    )
  }
)

Cta.propTypes = {
  text: PropTypes.string.isRequired,
  to: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  buttonType: PropTypes.string,
  bgColor: PropTypes.string,
  textColor: PropTypes.string,
  customStateColors: PropTypes.object,
  icon: PropTypes.string,
  iconPosition: PropTypes.string,
  isDisabled: PropTypes.bool,
  blank: PropTypes.bool,
  fontSize: PropTypes.oneOf(['l', 'm', 's']),
}

export default Cta
